
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectModule } from 'primeng/select';
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from '../shared/services/project.service';

@Component({
  selector: 'app-orgswitcher',
  imports: [FormsModule, SelectModule],

  templateUrl: './orgswitcher.component.html',
  styleUrl: './orgswitcher.component.scss'
})
export class OrgswitcherComponent {
  constructor(
    public projectService: ProjectService,
    public loginService: LoginService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  // Haelt den ?org= Query-Param im Sync mit der Dropdown-Auswahl (auch beim Abwaehlen)
  public onOrgChange(org?: string): void {
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { org: org || null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

}
